<template>
  <transition name="fade">
    <div id="login" class="text-center">
      <div class="row">
        <div class="col bg-white rounded p-4">
          <form class="form-login" @submit.prevent="auth">
            <img
              v-if="!isLoading"
              class="mb-4"
              style="width:200px"
              src="./assets/GS_corpuls.png"
            />
            <!-- <h2 class=" my-3">Please sign in</h2> -->
            <div id="auth-messages" class="auth-messages text-danger mb-2"></div>
            <div v-if="isLoading" class>
              <PleaseWait></PleaseWait>
            </div>

            <div v-if="!isLoading">
              <label for="inputEmail" class="sr-only">Email address</label>
              <input
                type="text"
                id="inputEmail"
                class="form-control"
                placeholder="Email address or username"
                autofocus
                autocomplete="off"
                autocapitalize="none"
              />
              <label for="inputPassword" class="sr-only">Password</label>
              <input
                type="password"
                id="inputPassword"
                class="form-control mt-2"
                placeholder="Password"
                autocomplete="off"
              />

              <button class="btn btn-lg btn-primary btn-block mt-3" type="submit">Sign in</button>

              <button type="button" class="btn mt-3" @click="showModal">Forgotten Password?</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row text-center footer-privacy">
        <div class="col-12">
          Copyright 2021 GS Elektromedizinische Geräte G. Stemple GmbH<br>
          For more information please refer to our <a href="https://corpuls.world/en/legal/imprint/">Imprint</a> and <a href="https://corpuls.world/en/legal/privacy-policy/">Privacy Policy</a>
        </div>
      </div>
      <ForgotPasswordModal v-show="isForgotPasswordModalVisible" @close="closeModal"></ForgotPasswordModal>
    </div>
  </transition>
</template>

<script>
import UserService from "./services/user.service";
import ForgotPasswordModal from "./components/ForgotPasswordModal";
import PleaseWait from "./components/PleaseWait";

export default {
  name: "Login",
  computed: {
  },

  data() {
    return {
      isForgotPasswordModalVisible: false,
      isLoading: false,
    };
  },

  components: {
    ForgotPasswordModal,
    PleaseWait,
  },

  methods: {
    auth: function() {
      this.isLoading = true;
      
      document.getElementById("auth-messages").innerText = "";
      document.getElementById("auth-messages").style.display = "hidden";
      UserService.auth(
        document.getElementById("inputEmail").value,
        document.getElementById("inputPassword").value
      )
      .catch(() => {
        document.getElementById("auth-messages").innerText =
          "Incorrect username or password!";
        document.getElementById("auth-messages").style.display = "block";
      })
      .finally(() => this.isLoading = false);
    },

    showModal() {
      this.isForgotPasswordModalVisible = true;
    },

    closeModal() {
      this.isForgotPasswordModalVisible = false;
    }
  }
};
</script>

<style scoped>
#app {
}

h2,
h3,
h4,
h5 {
  color: #CB2E37;
  font-weight: 600;
}
h2,
h3 {
  font-weight: 500;
}

.form-login {
  max-width: 340px;
  margin: auto;
}
.auth-messages {
  display: none;
}

#login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

#login .row .col {
  min-width: 50vw;
}

#login .footer-privacy {
  margin-top: 50px;
  margin-bottom: 20px;
  font-style: italic;
  font-size: 15px;
}

</style>
